import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import projects, { tags } from '../data/projects';
import Nav from './Nav';
import Footer from './Footer';
import './ProjectPage.scss';

const ProjectPage = () => {
  const { slug } = useParams();
  const project = projects.find(p => p.slug === slug);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const gallery = project?.gallery || [];

  const prev = () => setLightboxIndex(i => (i - 1 + gallery.length) % gallery.length);
  const next = () => setLightboxIndex(i => (i + 1) % gallery.length);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setLightboxIndex(null);
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [gallery.length]);

  if (!project) {
    return (
      <div className="project-404">
        <p>Projet introuvable.</p>
        <Link to="/">← Retour</Link>
      </div>
    );
  }

  return (
    <div className="project-page">
      <Nav alwaysVisible />

      <div className="project-page__hero">
        <div className="project-page__hero-bg" style={{ backgroundImage: `url(${project.img})` }} />
        <div className="project-page__hero-overlay">
          {project.logo
            ? <img src={project.logo} alt={project.title} className="project-page__logo" />
            : <h1 className="project-page__title">{project.title}</h1>
          }
          <div className="project-page__tags">
            {(project.tags || tags).map(tag => (
              <span className="project-page__tag" key={tag}>{tag}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="project-page__content">
        <div className="project-page__body">
          <h2 className="project-page__section-title">{project.title}</h2>
          {project.description.split('\n\n').map((para, i) => (
            <p className="project-page__desc" key={i}>{para}</p>
          ))}
        </div>
      </div>

      {project.gallery && (
        <div className="project-page__gallery">
          {project.gallery.map((img, i) => (
            <div className="project-page__gallery-item" key={i} onClick={() => setLightboxIndex(i)}>
              <img src={img} alt={`${project.title} ${i + 1}`} />
            </div>
          ))}
        </div>
      )}

      {lightboxIndex !== null && (
        <div className="lightbox" onClick={() => setLightboxIndex(null)}>
          <img src={gallery[lightboxIndex]} alt="" className="lightbox__img" onClick={e => e.stopPropagation()} />
          <button className="lightbox__close" onClick={() => setLightboxIndex(null)}>✕</button>
          {gallery.length > 1 && (
            <>
              <button className="lightbox__nav lightbox__nav--prev" onClick={e => { e.stopPropagation(); prev(); }}>&#8592;</button>
              <button className="lightbox__nav lightbox__nav--next" onClick={e => { e.stopPropagation(); next(); }}>&#8594;</button>
              <span className="lightbox__counter">{lightboxIndex + 1} / {gallery.length}</span>
            </>
          )}
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ProjectPage;
